import { render, staticRenderFns } from "./RoutesTab.vue?vue&type=template&id=5f81834a&"
import script from "./RoutesTab.vue?vue&type=script&lang=js&"
export * from "./RoutesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f81834a')) {
      api.createRecord('5f81834a', component.options)
    } else {
      api.reload('5f81834a', component.options)
    }
    module.hot.accept("./RoutesTab.vue?vue&type=template&id=5f81834a&", function () {
      api.rerender('5f81834a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/routes/RoutesTab.vue"
export default component.exports